import * as React from 'react';

import { IconSolidInfo } from '@notino/react-styleguide';

import { PortalTooltip } from '@components/PortalTooltip';

import {
  InfoIconWrapper,
  InstructionTextWrapper,
  TermsWrapper,
} from '../styled';

import { TooltipContent } from './styled';

interface TermsProps {
  instructionsText: JSX.Element;
  infoTooltipText: JSX.Element;
  inverseColor?: boolean;
}

export const VoucherTerms: React.FC<TermsProps> = ({
  infoTooltipText,
  instructionsText,
  inverseColor,
}) => {
  return (
    <TermsWrapper>
      <InstructionTextWrapper hasContrastBg={inverseColor}>
        {instructionsText}

        {infoTooltipText && (
          <PortalTooltip
            content={
              <PortalTooltip.Content>
                <TooltipContent>{infoTooltipText}</TooltipContent>
              </PortalTooltip.Content>
            }
          >
            <InfoIconWrapper>
              <IconSolidInfo
                width="13px"
                height="13px"
                color={inverseColor ? 'icon.inverse' : 'icon.tertiary'}
              />
            </InfoIconWrapper>
          </PortalTooltip>
        )}
      </InstructionTextWrapper>
    </TermsWrapper>
  );
};
